import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RedditSubmissionsComponent } from './Components/reddit-submissions/reddit-submissions.component';


export const redditRouting: Routes = [
  {
    path: '',
    component: RedditSubmissionsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(redditRouting)],
  exports: [RouterModule],
})
export class RedditRoutingModule {}
